import { render, staticRenderFns } from "./payProject.vue?vue&type=template&id=ff2b8c7c&scoped=true&"
import script from "./payProject.vue?vue&type=script&lang=js&"
export * from "./payProject.vue?vue&type=script&lang=js&"
import style0 from "./payProject.vue?vue&type=style&index=0&id=ff2b8c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2b8c7c",
  null
  
)

export default component.exports